<template>
  <div class="contaier">
    <Topbar></Topbar>
    <router-view :key="this.$route.fullPath" />
    <Footer></Footer>
  </div>
</template>

<script>
import Topbar from "@/components/TopBar.vue";
import Footer from "@/components/MainFooter.vue";
import { useStore } from "vuex";
import axios from "axios";
import { Date } from "core-js";

export default {
  name: "App",
  components: {
    Topbar,
    Footer,
  },
  data() {
    return {
      gap_time: 0,
      beforeUnload_time: 0,
      store: useStore(),
    };
  },
  methods: {
    //关闭窗口之前执行
    beforeunloadHandler() {
      this.beforeUnload_time = new Date().getTime();
    },
    unloadHandler() {
      this.gap_time = new Date().getTime() - this.beforeUnload_time;
      //判断是窗口关闭还是刷新 毫秒数判断 网上大部分写的是5
      if (this.gap_time <= 10) {
        const tokenDto = {
          token: this.store.state.userInfo.token,
          refreshToken: this.store.state.userInfo.refreshToken,
        };
        axios
          .post("/Login/out", tokenDto, {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          })
          .then((response) => {
            // 处理接口返回的结果
            if (response.data.code === 200) {
              console.log("------", this.store.state.userInfo);
              this.store.commit("removeUserInfo");
            }
          })
          .catch((error) => {
            // 处理请求错误
            console.error("获取留言列表失败", error);
          });
      } else {
        console.log(this.store.state.userInfo);
        return confirm("确定关闭？");
      }
    },
  },

  mounted() {
    const host = window.location.host;
    if (host) {
      document.title = host.includes("fjkkauto")
        ? "福建科控自动化科技有限公司-官网"
        : "北京凯创通达科技有限公司-官网";
    } else {
      document.title = "福建科控自动化科技有限公司-官网";
    }
    //监听浏览器关闭
    window.addEventListener("beforeunload", () => this.beforeunloadHandler());
    window.addEventListener("unload", () => this.unloadHandler());
  },
  unmounted() {
    // 关闭浏览器执行退出接口
    window.removeEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    window.removeEventListener("unload", (e) => this.unloadHandler(e));
  },
};
</script>

<style>
html,
body {
  background: #fff;
  width: 100%;
  margin: 0px;
  padding: 0px;
  font-size: 14px;
}
.contaier {
  background: #fff;
}
.contaier .inner {
  width: 80%;
  margin: 0 auto;
  min-width: 1024px;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.flex-item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
</style>
